import type { AxiosInstance } from "axios";
import { apiClient } from "@/data/axiosConfig";
import { getIntegrationIntakeBaseUrl } from "@forms/form-render/http/intakeIntegrationRouting";

export interface FileUploadInfo {
  path: string;
  filename: string;
  contentType: string;
  url: string;
}

export function createFileUploadApi(client: AxiosInstance) {
  const getProxyUrl = (enquiryId: string, path: string): string => {
    const query = `enquiryId=${encodeURIComponent(enquiryId)}&path=${encodeURIComponent(path)}`;
    const base = getIntegrationIntakeBaseUrl();
    if (base) {
      return `${base}/api/file-uploads/proxy?${query}`;
    }
    return `/api/file-uploads/proxy?${query}`;
  };

  return {
    getProxyUrl,

    upload: async (
      enquiryId: string,
      file: File,
      elementDisplayId: string,
      inputDisplayId: string
    ): Promise<FileUploadInfo> => {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("elementDisplayId", elementDisplayId);
      formData.append("inputDisplayId", inputDisplayId);

      const response = await client.post<FileUploadInfo>(`/api/file-uploads/${enquiryId}`, formData);
      return response.data;
    },

    list: async (
      enquiryId: string,
      elementDisplayId: string,
      inputDisplayId: string
    ): Promise<FileUploadInfo[]> => {
      const response = await client.get<FileUploadInfo[]>(`/api/file-uploads/${enquiryId}`, {
        params: {
          elementDisplayId,
          inputDisplayId,
        },
      });
      return response.data;
    },

    delete: async (
      enquiryId: string,
      elementDisplayId: string,
      inputDisplayId: string,
      path: string
    ): Promise<void> => {
      await client.delete(`/api/file-uploads/${enquiryId}`, {
        params: {
          elementDisplayId,
          inputDisplayId,
          path,
        },
      });
    },
  };
}

export const fileUploadApi = createFileUploadApi(apiClient);
